import styles from './anzeigenSaeule.module.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

function AnzeigenSaeule({ icon, iconAlt, text_html, iconBig }) {
    const navigate = useNavigate();

    const parsedHtml = parse(text_html, {
        replace: domNode => {
            if (
                domNode.name === 'a' &&
                domNode.attribs?.href &&
                domNode.attribs.href.startsWith('/')
            ) {
                const to = domNode.attribs.href;
                return (
                    <span
                        onClick={() => navigate(to)}
                        className={styles.linkLike}
                        role="link"
                        tabIndex={0}
                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate(to)}
                    >
                        {domNode.children.map(child => child.data).join('')}
                    </span>
                );
            }
        }
    });

    return (
        <div className={styles.container}>
            {icon && (
                <div className={styles.iconWrapper} aria-label={iconAlt} title={iconAlt}>
                    {typeof icon === 'string' ? (
                        <img
                            src={icon}
                            alt={iconAlt}
                            className={`${styles.iconImage} ${iconBig ? styles.iconImageBig : ''}`}
                        />
                    ) : (
                        icon && React.createElement(icon, { className: styles.iconComponent })
                    )}
                </div>
            )}
            <div className={styles.text}>
                {parsedHtml}
            </div>
        </div>
    );
}

export default AnzeigenSaeule;
